<template>
  <v-footer no-gutters padless class="d-block transparent">
    <Slope v-if="!side" :borderRight="true" :padless="true">
      <v-container>
        <v-row class="mt-10" style="padding-top: 8vw">
          <v-col cols="12" sm="6">
            <Logo :width="140" />
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col v-for="(item, i) in footer" :key="i" cols="12" sm="6">
                <div>
                  <p class="font-weight-bold mb-2">
                    {{ item.text }}
                  </p>

                  <ul style="list-style-type: none; padding: 0;">
                    <li v-for="(subItem, j) in item.subList" :key="j">
                      <a
                        :href="`${subItem.href ? subItem.href : '#'}`"
                        class="link"
                      >
                        {{ subItem.text }}</a
                      >
                    </li>
                  </ul>
                </div></v-col
              >
            </v-row></v-col
          >
        </v-row>

        <hr class="my-6" />

        <v-row>
          <v-col cols="12" md="6" class="text-left mt-n1">
            <!-- <a
              v-for="(social, index) in socials"
              :key="index"
              target="_blank"
              :href="social.handle"
              style="text-decoration: none"
            >
              <v-btn class="mx-1" dark fab depressed x-small color="primary">
                <v-icon dark>
                  {{ social.icon }}
                </v-icon>
              </v-btn>
            </a> -->
            <a
              v-for="(text, i) in ['Terms of Service', 'Privacy Policy']"
              :key="i"
              href="#"
              style="text-decoration: none"
              >{{ text }}<span v-if="i < 1" class="mx-3">&bull;</span>
            </a>
          </v-col>
          <v-col cols="12" md="6" class="text-left text-md-right primary--text">
            <p>&copy; {{ currentYear }} Polyticks</p>
          </v-col>
        </v-row>
      </v-container>
    </Slope>

    <div v-else class="text-center pa-1 mx-auto d-flex justify-center">
      <Logo />
    </div>
  </v-footer>
</template>

<script>
import Logo from "@/components/Logo.vue";
import footer from "../api/footer.js";
import { Slope } from "@/templates";

export default {
  name: "PageFooter",

  props: ["side"],

  components: {
    Logo,
    Slope,
  },

  data: () => ({
    footer,

    socials: [
      {
        icon: "mdi-instagram",
        handle: "#",
      },
      { icon: "mdi-twitter", handle: "#" },
      { icon: "mdi-facebook", handle: "#" },
    ],
  }),

  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.link {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  line-height: 200%;
}

.link:hover,
.link:active,
.link:focus {
  text-decoration: underline;
  color: #7a73ff;
}

* {
  color: var(--v-primary-base);
}
</style>
